import ValidationType from '../ValidationType';
import { datesAreEqual, dateIsBefore } from "../../dateutil";
import moment from 'moment-timezone';

class BeforeDateIn extends ValidationType {
  validateResponseWithValidation(fieldResponse, validation) {
    let errors = [];
    if (!fieldResponse.isEmpty) {
      
      const current = moment(fieldResponse.currentValue).utcOffset(moment(fieldResponse.currentValue).utcOffset() ).format('YYYY-MM-DD');
      const compare = moment(validation.value).utcOffset(moment(validation.value).utcOffset()).format('YYYY-MM-DD');
        
      if (!datesAreEqual(current, compare) && !dateIsBefore(current, compare)) {
        const error = this.createValidationError({
          fieldResponse,
          key: 'ERROR_BEFORE_SPECIFIED_DATE_IN',
          values: { value: validation.value },
          message: `Value should be equal to or before '${compare}'`,
        });
        errors.push(error);
      }
    }
    return errors;
  }
}

export default BeforeDateIn;
